import React from 'react';
import { Box, HStack, Text, Icon } from '@chakra-ui/react';
import { GiScales } from 'react-icons/gi';
import { FaShieldAlt, FaBalanceScale } from 'react-icons/fa';

const Marquee = ({
    title = "Ձեր Իրավունքի պաշտպանությունը մեր առաքելությունն է։",
    bgColor = "#0b132b",
    speed = 28
}) => {
    const items = [
        { text: title, icon: GiScales },
        { text: "100% Գաղտնիություն և Պրոֆեսիոնալիզմ", icon: FaShieldAlt },
        { text: "Բարձրակարգ Իրավաբանական և Փաստաբանական Սպասարկում", icon: FaBalanceScale },
        { text: "Հուսալի Իրավական Գործընկեր Հայաստանում", icon: GiScales },
    ];

    return (
        <Box
            bg={bgColor}
            py={3.5}
            overflow="hidden"
            position="relative"
            borderTop="1px solid rgba(223, 186, 115, 0.2)"
            borderBottom="1px solid rgba(223, 186, 115, 0.2)"
            boxShadow="inset 0 0 20px rgba(0, 0, 0, 0.3)"
        >
            <Box
                display="flex"
                w="max-content"
                animation={`marqueeScroll ${speed}s linear infinite`}
                _hover={{ animationPlayState: 'paused' }}
            >
                {/* Render two identical groups for seamless infinite loop */}
                {[...items, ...items].map((item, idx) => (
                    <HStack key={idx} spacing={4} px={8} flexShrink={0}>
                        <Icon as={item.icon} color="#dfba73" fontSize="16px" />
                        <Text
                            color="gray.200"
                            fontSize={{ base: "xs", md: "sm" }}
                            fontWeight="600"
                            letterSpacing="0.04em"
                            textTransform="uppercase"
                        >
                            {item.text}
                        </Text>
                        <Box w={1.5} h={1.5} borderRadius="full" bg="#dfba73" opacity={0.6} />
                    </HStack>
                ))}
            </Box>

            <style>{`
                @keyframes marqueeScroll {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-50%); }
                }
            `}</style>
        </Box>
    );
};

export default Marquee;